import { useState } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d6iqafefj9ym2lq4suj0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-32 px-8 bg-dark-primary pb-24">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{ backgroundImage: 'linear-gradient(#cbd5e1 1px, transparent 1px), linear-gradient(90deg, #cbd5e1 1px, transparent 1px)', backgroundSize: '64px 64px' }}></div>

      <div className="relative max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-industrial-lighter/20 rounded-full mb-8">
          <span className="text-industrial-lighter text-xs font-medium tracking-[0.12em] uppercase">
            Technical Inquiries
          </span>
        </div>

        <h2 className="font-serif text-white text-4xl leading-tight mb-6">
          Technical Inquiries
        </h2>

        <p className="text-industrial-light text-base leading-[1.8] mb-12 max-w-2xl mx-auto">
          For information regarding manufacturing surveillance requirements, supply chain verification services, or project-specific technical applications, contact Arvakon technical services.
        </p>

        <a
          href="/contact#inquiry-form"
          className="inline-block bg-white text-dark-primary px-10 py-4 rounded-md font-medium text-sm tracking-wide hover:bg-industrial-lighter transition-colors whitespace-nowrap cursor-pointer"
        >
          Submit Technical Inquiry
        </a>
      </div>
    </section>
  );
}